/**
 * @param input {HTMLInputElement}
 * @return {null | HTMLLabelElement}
 */
module.exports = function getLabelForInput(input) {
    const label = window.document.querySelector(`[for="${input.id}"]`);

    if (label instanceof HTMLLabelElement) {
        return label;
    }

    return null;
}
